import React, { useEffect, useState, useContext } from "react";
import { Container, Spinner } from "react-bootstrap";
import axios from "axios";
import AppContext from "../../../context/AppContext";
import "../../../assets/css/customer/dashboard/MyAppointments.css";
import { checkLoggedInCustomer } from "../../../helper/CustomHelper";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

/* ───────── STATUS BADGE ───────── */

const SgcStatusBadge = ({ status }) => {
  const classMap = {
    Approved: "sgc-appt-badge sgc-appt-badge-approved",
    Pending: "sgc-appt-badge sgc-appt-badge-pending",
    Rejected: "sgc-appt-badge sgc-appt-badge-rejected",
    Cancelled: "sgc-appt-badge sgc-appt-badge-rejected",
  };

  return <span className={classMap[status] || "sgc-appt-badge"}>{status}</span>;
};

const MyAppointments = () => {
  const { baseUrl, baseUrlForFile } = useContext(AppContext);
  const navigate = useNavigate();

  const [appointments, setAppointments] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selected, setSelected] = useState(null);

  const [newDate, setNewDate] = useState("");
  const [newTime, setNewTime] = useState("");

  const [loading, setLoading] = useState(false);
  const [loadingBtn, setLoadingBtn] = useState(null);

  /* =====================================================
     VIEW ALL APPOINTMENTS
  ===================================================== */

  const viewAllAppointments = () => {
    const escustomerId = localStorage.getItem("customerId");

    axios
      .get(`${baseUrl}/customer/appointment/viewMyAppointments`, {
        params: { escustomer_id: escustomerId },
      })
      .then((response) => {
        const data =
          response.data?.appointments || response.data?.data || response.data;

        setAppointments(Array.isArray(data) ? data : []);
      })
      .catch((error) => {
        setAppointments([]);
        Swal.fire({
          icon: "error",
          title: "Unable to Load Appointments",
          text:
            error.response?.data?.message ||
            "Something went wrong while loading your appointments.",
          confirmButtonColor: "#e0456e",
        });
      });
  };

  // const viewAllAppointments = () => {
  //   axios
  //     .get(`${baseUrl}/customer/appointment/viewAllAppointments`)
  //     .then((response) => {
  //       console.log("APPOINTMENTS:", response.data);

  //       const data =
  //         response.data?.appointments ||
  //         response.data?.data ||
  //         response.data;

  //       if (Array.isArray(data)) {
  //         setAppointments(data);
  //       } else {
  //         setAppointments([]);
  //       }
  //     })
  //     .catch((error) => {
  //       console.log("APPOINTMENTS ERROR:", error);

  //       setAppointments([]);

  //       Swal.fire({
  //         icon: "error",
  //         title: "Unable to Load Appointments",
  //         text:
  //           error.response?.data?.message ||
  //           "Something went wrong while loading your appointments.",
  //         confirmButtonColor: "#e0456e",
  //       });
  //     });
  // };

  /* =====================================================
     OPEN RESCHEDULE MODAL
  ===================================================== */

  const openModal = (appt) => {
    setLoadingBtn(`${appt.id}-reschedule`);

    setSelected(appt);
    setNewDate(appt.appointment_date || "");
    setNewTime(appt.appointment_time || "");
    setShowModal(true);

    setTimeout(() => {
      setLoadingBtn(null);
    }, 500);
  };

  /* =====================================================
     RESCHEDULE APPOINTMENT
  ===================================================== */

  const reschedule = () => {
    if (!selected) {
      return;
    }

    if (!newDate) {
      Swal.fire({
        icon: "warning",
        title: "Date Required",
        text: "Please select an appointment date.",
        confirmButtonColor: "#e0456e",
      });

      return;
    }

    if (!newTime) {
      Swal.fire({
        icon: "warning",
        title: "Time Required",
        text: "Please select an appointment time.",
        confirmButtonColor: "#e0456e",
      });

      return;
    }

    setLoading(true);

    const formData = new FormData();

    formData.append("id", selected.id);
    formData.append("appointment_date", newDate);
    formData.append("appointment_time", newTime);

    axios
      .post(`${baseUrl}/customer/appointment/updateAppointment`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log("RESCHEDULE RESPONSE:", res.data);

        setShowModal(false);
        setSelected(null);

        Swal.fire({
          icon: "success",
          title: "Appointment Updated!",
          text: "Your appointment has been rescheduled successfully.",
          confirmButtonText: "OK",
          confirmButtonColor: "#e0456e",
        });

        viewAllAppointments();
      })

      .catch((err) => {
        console.log("RESCHEDULE ERROR:", err);

        Swal.fire({
          icon: "error",
          title: "Update Failed!",
          text:
            err.response?.data?.message ||
            err.response?.data?.error ||
            "Something went wrong. Please try again.",
          confirmButtonText: "OK",
        });
      })
      // .catch((err) => {
      //   console.log("RESCHEDULE ERROR:", err);

      //   Swal.fire({
      //     icon: "error",
      //     title: "Update Failed!",
      //     text:
      //       err.response?.data?.message ||
      //       err.response?.data?.error ||
      //       "Something went wrong. Please try again.",
      //     confirmButtonText: "OK",
      //     confirmButtonColor: "#e0456e",
      //   });
      // })
      .finally(() => {
        setLoading(false);
      });
  };

  /* =====================================================
     CANCEL APPOINTMENT
  ===================================================== */

  const cancelAppointment = (id) => {
    setLoadingBtn(`${id}-cancel`);

    Swal.fire({
      title: "Cancel Appointment?",
      text: "Are you sure you want to cancel this appointment?",
      icon: "warning",

      showCancelButton: true,

      confirmButtonText: "Yes, Cancel",
      cancelButtonText: "No",

      confirmButtonColor: "#e0456e",
      cancelButtonColor: "#6c757d",

      reverseButtons: true,
    }).then((result) => {
      if (!result.isConfirmed) {
        setLoadingBtn(null);
        return;
      }

      Swal.fire({
        title: "Cancelling Appointment...",
        text: "Please wait.",
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,

        didOpen: () => {
          Swal.showLoading();
        },
      });

      axios
        .post(`${baseUrl}/customer/appointment/deleteAppointment`, { id })
        .then((res) => {
          console.log("CANCEL RESPONSE:", res.data);

          Swal.fire({
            icon: "success",
            title: "Cancelled!",
            text: "Your appointment has been cancelled successfully.",
            confirmButtonText: "OK",
            confirmButtonColor: "#e0456e",
          });

          viewAllAppointments();
        })
        .catch((err) => {
          console.log("CANCEL ERROR:", err);

          Swal.fire({
            icon: "error",
            title: "Cancellation Failed!",
            text:
              err.response?.data?.message ||
              err.response?.data?.error ||
              "Something went wrong. Please try again.",
            confirmButtonText: "OK",
            confirmButtonColor: "#e0456e",
          });
        })
        .finally(() => {
          setLoadingBtn(null);
        });
    });
  };

  /* =====================================================
     CLOSE MODAL
  ===================================================== */

  const closeModal = () => {
    setLoadingBtn("close");

    setShowModal(false);
    setSelected(null);

    setNewDate("");
    setNewTime("");

    setTimeout(() => {
      setLoadingBtn(null);
    }, 500);
  };

  /* =====================================================
     CHECK LOGIN + LOAD APPOINTMENTS
  ===================================================== */

  useEffect(() => {
    checkLoggedInCustomer(navigate);
    viewAllAppointments();
  }, []);

  /* =====================================================
     UI
  ===================================================== */

  return (
    <div className="sgc-appt-page">
      <Container fluid>
        <h1 className="sgc-appt-title">My Appointments</h1>

        {/* ───────── APPOINTMENT LIST ───────── */}

        {Array.isArray(appointments) && appointments.length > 0 ? (
          appointments.map((appt) => (
            <div className="sgc-appt-card" key={appt.id}>
              {/* IMAGE */}

              <img
                src={
                  appt.image
                    ? `${baseUrlForFile}/${appt.image}`
                    : "https://via.placeholder.com/140x120"
                }
                className="sgc-appt-thumb"
                alt="Appointment"
              />

              {/* INFORMATION */}

              <div className="sgc-appt-info">
                <div className="sgc-appt-info-top">
                  <p className="sgc-appt-name">{appt.treatment}</p>

                  <SgcStatusBadge status={appt.status} />
                </div>

                <p className="sgc-appt-meta">
                  {appt.appointment_date} at {appt.appointment_time}
                </p>

                {appt.notes && <p className="sgc-appt-notes">{appt.notes}</p>}
              </div>

              {/* ACTION BUTTONS */}

              <div className="sgc-appt-actions">
                {/* RESCHEDULE */}

                <button
                  className="sgc-appt-btn-reschedule"
                  onClick={() => openModal(appt)}
                  disabled={loadingBtn === `${appt.id}-reschedule`}
                >
                  {loadingBtn === `${appt.id}-reschedule` ? (
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  ) : (
                    "Reschedule"
                  )}
                </button>

                {/* CANCEL */}

                <button
                  className="sgc-appt-btn-cancel"
                  onClick={() => cancelAppointment(appt.id)}
                  disabled={loadingBtn === `${appt.id}-cancel`}
                >
                  {loadingBtn === `${appt.id}-cancel` ? (
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  ) : (
                    "Cancel"
                  )}
                </button>
              </div>
            </div>
          ))
        ) : (
          /* ───────── NO APPOINTMENTS ───────── */

          <div className="text-center mt-4">
            <p>No appointments found.</p>
          </div>
        )}
      </Container>

      {/* =====================================================
          RESCHEDULE MODAL
      ===================================================== */}

      {showModal && (
        <div className="modal show d-block">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content p-4">
              <h4>Reschedule Appointment</h4>

              {/* DATE */}

              <input
                type="date"
                className="form-control mb-2"
                value={newDate}
                onChange={(e) => setNewDate(e.target.value)}
              />

              {/* TIME */}

              <select
                className="form-control mb-3"
                value={newTime}
                onChange={(e) => setNewTime(e.target.value)}
              >
                <option value="">Select Time</option>

                <option>09:00 AM</option>
                <option>10:00 AM</option>
                <option>11:00 AM</option>
                <option>12:00 PM</option>
                <option>01:00 PM</option>
                <option>02:00 PM</option>
                <option>03:00 PM</option>
                <option>04:00 PM</option>
                <option>05:00 PM</option>
              </select>

              {/* MODAL BUTTONS */}

              <div className="d-flex gap-2">
                {/* UPDATE */}

                <button
                  className="sgc-book-btn"
                  onClick={reschedule}
                  disabled={loading}
                >
                  {loading ? (
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  ) : (
                    "Update"
                  )}
                </button>

                {/* CLOSE */}

                <button
                  className="btn btn-secondary"
                  onClick={closeModal}
                  disabled={loadingBtn === "close"}
                >
                  {loadingBtn === "close" ? (
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  ) : (
                    "Close"
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MyAppointments;
